var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("@/assets/images/ad/ad2/25.png"),"alt":""}}),_c('div',{staticClass:"btn-box"},[_c('a',{staticClass:"btn",attrs:{"href":"https://www.wjx.top/vm/wFoDDG0.aspx"}},[_vm._v("点击报名")])])])])
}]

export { render, staticRenderFns }